// extracted by mini-css-extract-plugin
module.exports = {"articlePageLayout":"ArticlePageLayout_articlePageLayout___O_mj","hasLeftPanel":"ArticlePageLayout_hasLeftPanel__oCqQ3","hasRightPanel":"ArticlePageLayout_hasRightPanel__Ngs_u"};